<template>
  <div>
    <PageTitle :route="$route"></PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <OsFinishedList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import ActionButton from "@/components/button/ActionButton";
import OsFinishedList from "@/components/osfinished/OsFinishedList";

export default {
  name: "OsFinished",
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    OsFinishedList,
  },
};
</script>
